// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 5271) return "5271.a0339980ac797341d07b.js";
	// return url for filenames based on template
	return "" + {"1167":"fd7e0aacf7e248b88475","5172":"c1e422c214c634233d90"}[chunkId] + ".js";
};